// components
import GooglCapture from '@/components/googlCapture';
import { Dialog } from '@/components/tdesign';
// type
import type { GoogleCaptureErrorEnum } from '@/components/googlCapture';
// utils
import { GoogleCaptchaVersionEnum } from '../utils/typing/login';

type PropsType = {
  visible?: boolean;
  version?: string;
  onChange: (val: any) => void;
  onClose?: () => void;
  onFail?: (errorType?: GoogleCaptureErrorEnum) => void;
};

function GoogleVerify(props: PropsType, ref: any) {
  const {
    visible = false,
    version = GoogleCaptchaVersionEnum.V2,
    onChange,
    onClose,
    onFail,
  } = props;

  return version === GoogleCaptchaVersionEnum.V3 ? (
    <GooglCapture version={version} onChange={onChange} onFail={onFail} />
  ) : (
    <Dialog
      visible={visible}
      isShowBtn={false}
      placement="center"
      width="auto"
      dialogProps={{
        zIndex: 10000,
      }}
      destroyOnClose
      onClose={onClose}
    >
      <GooglCapture
        version={version}
        onChange={(val: any) => {
          onClose?.();
          onChange?.(val);
        }}
        onFail={onFail}
      />
    </Dialog>
  );
}

export default GoogleVerify;
